export class AdventureMan {
	public row: number = 0;
	public column: number = 0;
	public index: number = 0;
	public win: boolean = false;
}